var render = function render(){var _vm=this,_c=_vm._self._c;return _c('additional-features',{attrs:{"additional-features-details":_vm.additionalFeaturesDetails}})
}
var staticRenderFns = []

export { render, staticRenderFns }